import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { OurproductComponent } from './ourproduct/ourproduct.component';
import { ManagedserviceComponent } from './managedservice/managedservice.component';
import { CompanyComponent } from './company/company.component';
import { CareerComponent } from './career/career.component';
import { ContactusComponent } from './contactus/contactus.component';
import { BrowserModule } from '@angular/platform-browser';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { NewsComponent } from './news/news.component';
import { AboutComponent } from './about/about.component';
import { ClientComponent } from './client/client.component';
import { ProjectengineeringComponent } from './projectengineering/projectengineering.component';
import { GccodcsolutionsComponent } from './gccodcsolutions/gccodcsolutions.component';
import { TestimonialsComponent } from './testimonials/testimonials.component';
import { TechnologyComponent } from './technology/technology.component';
import { IndustriesComponent } from './industries/industries.component';
import { AdvancesolutionComponent } from './advancesolution/advancesolution.component';
import { StaffingComponent } from './staffing/staffing.component';
import { DatamgmtComponent } from './datamgmt/datamgmt.component';
import { SitemapComponent } from './sitemap/sitemap.component';
import { AiComponent } from './ai/ai.component';
import { ProductDetailComponent } from './productDetail/productDetail.component';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { ToastrModule } from 'ngx-toastr';




const routes: Routes = [
  {path: '', component: HomeComponent},
  {path: 'advance-solution', component: AdvancesolutionComponent},
  {path: 'technology', component: TechnologyComponent},
  {path: 'industries', component: IndustriesComponent},
  {path: 'product', component: OurproductComponent},
  {path: 'product-detail/:tab', component: ProductDetailComponent},
  {path: 'product-detail', component: ProductDetailComponent},
  {path: 'manage-service', component: ManagedserviceComponent},
  {path: 'career', component: CareerComponent},
  {path: 'contact', component: ContactusComponent},
  {path: 'news-events', component: NewsComponent},
  {path: 'about', component: AboutComponent},
  {path: 'testimonials', component: TestimonialsComponent},
  {path: 'clients', component: ClientComponent},
  {path: 'clients', component: ClientComponent},
  {path: 'software-engineering/:tab', component: ProjectengineeringComponent},
  {path: 'software-engineering', component: ProjectengineeringComponent},
  {path: 'staffing-services/:tab', component: StaffingComponent},
  {path: 'staffing-services', component: StaffingComponent},
  {path: 'data-services/:tab', component: DatamgmtComponent},
  {path: 'data-services', component: DatamgmtComponent},
  {path: 'gcc-odc-solutions/:tab', component: GccodcsolutionsComponent},
  {path: 'gcc-odc-solutions', component: GccodcsolutionsComponent},
  // {path: 'sitemap', component: SitemapComponent},
  {path: 'ai', component: AiComponent}

];

@NgModule({
  declarations: [
    AdvancesolutionComponent,
    HomeComponent,
    OurproductComponent,
    ProductDetailComponent,
    ManagedserviceComponent,
    CompanyComponent,
    CareerComponent,
    ContactusComponent,
    NewsComponent,
    AboutComponent,
    ClientComponent,
    TechnologyComponent,
    IndustriesComponent,
    ProjectengineeringComponent,
    TestimonialsComponent,
    StaffingComponent,
    DatamgmtComponent,
    SitemapComponent,
    AiComponent,
    GccodcsolutionsComponent
],
  imports: [
    RouterModule.forRoot(routes, { scrollPositionRestoration: 'enabled', }),
    BrowserModule,
    NgbModule,
    ToastrModule.forRoot({ positionClass: "toast-bottom-right" }),
    ReactiveFormsModule,
    FormsModule,
    SlickCarouselModule
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
